<!-- @prettier -->
<template>
  <ConfirmationModal
    :entity="publisher"
    :title="$t('PAUSE_AFFILIATE_MODAL_TITLE')"
    :cancel-button-text="$t('PAUSE_AFFILIATE_MODAL_CANCEL_ACTION')"
    :confirm-action-text="$t('PAUSE_AFFILIATE_MODAL_CONFIRM_ACTION')"
    :show-cancel-button="showActions"
    :show-confirm-button="showActions"
    @confirm="confirmPause"
    @close="closePauseModal"
  >
    <p
      v-html="
        $t('PAUSE_AFFILIATE_MODAL_TEXT', { affiliateName: publisher.name })
      "
    ></p>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from '@/core/components/ConfirmationModal/ConfirmationModal';
import sharedMessages from '@/core/locales';
import messages from '../locales';

export default {
  name: 'PublisherPauseModal',
  components: {
    ConfirmationModal
  },
  props: {
    publisher: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    showActions() {
      return !!this.publisher;
    }
  },
  methods: {
    confirmPause(publisher) {
      this.$emit('confirm', publisher, false);
    },
    closePauseModal() {
      this.$emit('close');
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>
